
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 82","d":"M27.9 0H4.1A4.113 4.113 0 000 4.129v15.742A4.113 4.113 0 004.1 24h23.8a4.113 4.113 0 004.1-4.129V4.129A4.113 4.113 0 0027.9 0z","fill":"#0071c0"}}),_c('path',{attrs:{"data-name":"Path 83","d":"M20.242 8.87q-.016.107-.037.22a3.809 3.809 0 01-4.175 3.414h-1.062a.52.52 0 00-.5.453l-.543 3.57-.157 1.012a.278.278 0 00.267.325h1.878a.457.457 0 00.445-.4l.018-.1.353-2.33.023-.128a.457.457 0 01.445-.4h.28a3.332 3.332 0 003.654-2.978 2.626 2.626 0 00-.376-2.246 1.8 1.8 0 00-.513-.412z","fill":"#99c6e5"}}),_c('path',{attrs:{"data-name":"Path 84","d":"M19.746 8.663q-.109-.033-.225-.06t-.237-.046a5.645 5.645 0 00-.932-.071h-2.823a.434.434 0 00-.195.046.467.467 0 00-.25.354l-.6 3.958-.018.112a.52.52 0 01.507-.452h1.057a3.809 3.809 0 004.176-3.418 6.74 6.74 0 00.037-.22 2.479 2.479 0 00-.391-.168l-.106-.035z","fill":"#cce2f2"}}),_c('path',{attrs:{"data-name":"Path 85","d":"M15.084 8.882a.465.465 0 01.25-.35.435.435 0 01.195-.046h2.823a5.645 5.645 0 01.932.071q.122.02.238.047t.224.06l.107.034a2.517 2.517 0 01.391.171 2.468 2.468 0 00-.49-2.154 3.492 3.492 0 00-2.747-.909h-3.6a.521.521 0 00-.515.453l-1.5 9.895a.318.318 0 00.305.372h2.228l.558-3.686z","fill":"#fff"}})])
          )
        }
      }
    